import { Reducer } from 'redux';
import {
    EPaymentProfileActionType,
    IPaymentProfile,
    IPaymentProfileAction,
} from 'modules/PaymentProfile/reducers/type';
import { Collection } from 'stores/type';

export const initialPaymentProfileState: Collection<IPaymentProfile> = {
    error: null,
    items: null,
    isLoading: true,
};

export const paymentProfileReducer: Reducer<Collection<IPaymentProfile>, IPaymentProfileAction> = (
    state = initialPaymentProfileState,
    action,
) => {
    const { type, data, error } = action;
    switch (type) {
        case EPaymentProfileActionType.FETCH_REQUESTED:
            return {
                ...state,
                isLoading: true,
            };
        case EPaymentProfileActionType.FETCH_SUCCEEDED:
            return {
                ...state,
                items: data,
                isLoading: false,
            };
        case EPaymentProfileActionType.FETCH_FAILED:
            return {
                ...state,
                error: error,
                isLoading: false,
            };
        case EPaymentProfileActionType.POST_SUCCEEDED:
            return {
                ...state,
                items: data,
            };
        default:
            return state;
    }
};

export type PaymentProfileState = typeof initialPaymentProfileState;
